import { render } from "./CapitalDistribution.vue?vue&type=template&id=b8a03f10&scoped=true&ts=true"
import script from "./CapitalDistribution.vue?vue&type=script&lang=ts"
export * from "./CapitalDistribution.vue?vue&type=script&lang=ts"

import "./CapitalDistribution.vue?vue&type=style&index=0&id=b8a03f10&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a03f10"]])

export default __exports__